import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class E11DropdownComponent {
    constructor() {
        this.name = 'Menu';
        this.displayIcon = true;
        this.btnColor = 'e11-text-black-700';
        this.btnBgColor = 'e11-bg-white-700';
        this.btnHoverBgColor = 'hover:e11-bg-white-800';
        this.btnFontWeight = 'e11-font-medium';
        this.btnRounded = 'e11-rounded-lg';
        this.btnTextAlign = 'e11-text-center';
        this.btnDisplay = 'e11-inline-flex';
        this.btnItemsAlign = 'e11-items-center';
        this.btnPaddingX = 'e11-px-4';
        this.btnPaddingY = 'e11-py-2.5';
        this.btnShadow = 'e11-shadow';
        this.btnFontSize = 'e11-text-sm';
        this.btnWidth = 'e11-w-auto'; // 'e11-w-full'
        this.dropdownZIndex = 'e11-z-10';
        this.dropdownWidth = 'e11-w-fit';
        this.dropdownFontSize = 'e11-text-base';
        this.dropdownListStyle = 'e11-list-none';
        this.dropdownBg = 'e11-bg-white-700';
        this.dropdownRounded = 'e11-rounded';
        this.dropdownDivide = 'e11-divide-y';
        this.dropdownDivideColor = 'e11-divide-gray-100';
        this.dropdownShadow = 'e11-shadow';
        this.selectedItem = new EventEmitter();
        this.displayList = false;
    }
    buttonStyle() {
        return [
            this.btnColor,
            this.btnBgColor,
            this.btnHoverBgColor,
            this.btnFontWeight,
            this.btnRounded,
            this.btnFontSize,
            this.btnPaddingX,
            this.btnPaddingY,
            this.btnTextAlign,
            this.btnDisplay,
            this.btnItemsAlign,
            this.btnShadow,
            this.btnWidth,
        ];
    }
    dropdownStyle() {
        const styles = [
            this.dropdownBg,
            this.dropdownDivide,
            this.dropdownDivideColor,
            this.dropdownListStyle,
            this.dropdownRounded,
            this.dropdownFontSize,
            this.dropdownWidth,
            this.dropdownZIndex,
            this.dropdownShadow,
        ];
        if (this.displayList) {
            styles.filter((style) => style === 'e11-hidden');
        }
        else {
            styles.push('e11-hidden');
        }
        return styles;
    }
    trackByIndex(index, photo) {
        return index;
    }
    selectItem(item) {
        this.selectedItem.emit(item);
    }
    toggleDisplay() {
        this.displayList = !this.displayList;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DropdownComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11DropdownComponent, selector: "e11-dropdown", inputs: { name: "name", displayIcon: "displayIcon", items: "items", btnColor: "btnColor", btnBgColor: "btnBgColor", btnHoverBgColor: "btnHoverBgColor", btnFontWeight: "btnFontWeight", btnRounded: "btnRounded", btnTextAlign: "btnTextAlign", btnDisplay: "btnDisplay", btnItemsAlign: "btnItemsAlign", btnPaddingX: "btnPaddingX", btnPaddingY: "btnPaddingY", btnShadow: "btnShadow", btnFontSize: "btnFontSize", btnWidth: "btnWidth", dropdownZIndex: "dropdownZIndex", dropdownWidth: "dropdownWidth", dropdownFontSize: "dropdownFontSize", dropdownListStyle: "dropdownListStyle", dropdownBg: "dropdownBg", dropdownRounded: "dropdownRounded", dropdownDivide: "dropdownDivide", dropdownDivideColor: "dropdownDivideColor", dropdownShadow: "dropdownShadow" }, outputs: { selectedItem: "selectedItem" }, ngImport: i0, template: "<div class=\"e11-dropdown\">\n  <button [ngClass]=\"buttonStyle()\" (click)=\"toggleDisplay()\">\n    <span class=\"e11-pr-2\">{{ name }}</span>\n    <span *ngIf=\"displayIcon\" class=\"material-icons e11-ml-2 e11-text-right\"> expand_more </span>\n  </button>\n\n  <!-- Dropdown menu -->\n  <div id=\"dropdown\" [ngClass]=\"dropdownStyle()\">\n    <ul class=\"e11-py-1 e11-list-none\" aria-labelledby=\"dropdownButton\">\n      <li *ngFor=\"let item of items; index as i; trackBy: trackByIndex\" class=\"e11-list-none\">\n        <a\n          href=\"javascript:void(0)\"\n          class=\"e11-block e11-py-2 e11-px-4 e11-text-sm e11-text-skin-base hover:e11-bg-gray-100\"\n          (click)=\"selectItem(item)\"\n        >\n          {{ item }}\n        </a>\n      </li>\n    </ul>\n  </div>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-dropdown', template: "<div class=\"e11-dropdown\">\n  <button [ngClass]=\"buttonStyle()\" (click)=\"toggleDisplay()\">\n    <span class=\"e11-pr-2\">{{ name }}</span>\n    <span *ngIf=\"displayIcon\" class=\"material-icons e11-ml-2 e11-text-right\"> expand_more </span>\n  </button>\n\n  <!-- Dropdown menu -->\n  <div id=\"dropdown\" [ngClass]=\"dropdownStyle()\">\n    <ul class=\"e11-py-1 e11-list-none\" aria-labelledby=\"dropdownButton\">\n      <li *ngFor=\"let item of items; index as i; trackBy: trackByIndex\" class=\"e11-list-none\">\n        <a\n          href=\"javascript:void(0)\"\n          class=\"e11-block e11-py-2 e11-px-4 e11-text-sm e11-text-skin-base hover:e11-bg-gray-100\"\n          (click)=\"selectItem(item)\"\n        >\n          {{ item }}\n        </a>\n      </li>\n    </ul>\n  </div>\n</div>\n" }]
        }], propDecorators: { name: [{
                type: Input
            }], displayIcon: [{
                type: Input
            }], items: [{
                type: Input
            }], btnColor: [{
                type: Input
            }], btnBgColor: [{
                type: Input
            }], btnHoverBgColor: [{
                type: Input
            }], btnFontWeight: [{
                type: Input
            }], btnRounded: [{
                type: Input
            }], btnTextAlign: [{
                type: Input
            }], btnDisplay: [{
                type: Input
            }], btnItemsAlign: [{
                type: Input
            }], btnPaddingX: [{
                type: Input
            }], btnPaddingY: [{
                type: Input
            }], btnShadow: [{
                type: Input
            }], btnFontSize: [{
                type: Input
            }], btnWidth: [{
                type: Input
            }], dropdownZIndex: [{
                type: Input
            }], dropdownWidth: [{
                type: Input
            }], dropdownFontSize: [{
                type: Input
            }], dropdownListStyle: [{
                type: Input
            }], dropdownBg: [{
                type: Input
            }], dropdownRounded: [{
                type: Input
            }], dropdownDivide: [{
                type: Input
            }], dropdownDivideColor: [{
                type: Input
            }], dropdownShadow: [{
                type: Input
            }], selectedItem: [{
                type: Output
            }] } });

class E11DropDownModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DropDownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11DropDownModule, declarations: [E11DropdownComponent], imports: [CommonModule], exports: [E11DropdownComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DropDownModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DropDownModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [E11DropdownComponent],
                    imports: [CommonModule],
                    exports: [E11DropdownComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11DropDownModule, E11DropdownComponent };
